import { DataTableRequestFilter } from '~/components/acurity-table/acurity-table';

export interface RequestControl {
	enable: boolean;
	reason: string;
}

export interface RequestControlMap {
	[index: string]: RequestControl;
}

export class RequestControlFilters {
	private atoRequest: DataTableRequestFilter;
	private requestStatus: DataTableRequestFilter;
}
